import type { CheckListItem } from './../../types/types.d';
import type { ElementGroupState, ElementInfo, ScreenType, StandardState, Image } from '../../types/types';

import store from '@/store';
import { MutationTypes } from '@modules/gem-meter/store/mutations';
import { SHOPABLE_PREFIX } from '../../constants/rulesConstants';
import { MODULE_NAME } from '../../constants/moduleConstants';
import { mutationTypes as editorMutations } from '@/store/editor/types';

export function getDataSetting() {
  return store.state.editor.dataSettings;
}

export function getShopableStandards(): StandardState {
  return store.state.gemMeter.shopableStandards;
}

export function getPageRules(): CheckListItem[] {
  return store.state.gemMeter.pageRules;
}

export function getElementsOfRules(): { [x: string]: ElementInfo } {
  return store.state.gemMeter.elementsOfRules;
}

export function getConvertableStandard(): StandardState {
  return store.state.gemMeter.convertableStandards;
}

export function commitStandardList(key: 'shopableStandards' | 'convertableStandards', standards: StandardState) {
  store.commit(`gemMeter/${MutationTypes.UPDATE_STANDARD_LIST}`, { key, standards });
}

export function commitPageRules(pageRules: CheckListItem[]) {
  store.commit(`gemMeter/${MutationTypes.UPDATE_PAGE_RULES}`, pageRules);
}

export function getElementGroup(): ElementGroupState {
  return store.state.gemMeter.elementGroups;
}

export function getImages(): Image[] {
  return store.state.gemMeter.images;
}

export function commitElementGroup(elementGroups: ElementGroupState) {
  return store.commit(`gemMeter/${MutationTypes.UPDATE_ELEMENT_GROUP}`, elementGroups);
}

export function getElementFromStore(elementId: string) {
  const dataSettings = getDataSetting();

  if (dataSettings && dataSettings.hasOwnProperty(elementId)) {
    return dataSettings[elementId];
  }

  return null;
}

export function getStandardByRuleId(ruleId: string) {
  if (ruleId?.includes(SHOPABLE_PREFIX)) {
    return getShopableStandards();
  } else {
    return getConvertableStandard();
  }
}

export function getScreenKey(): string {
  return store.state.app.currentScreen;
}

export function getScreenType(): ScreenType {
  return store.state.app.currentScreen;
}

export function getIsInitialize() {
  return store.state.gemMeter.isInitialize;
}

export function getScreenSize(): 'desktop' | 'mobile' {
  if (['xs', 'sm'].includes(getScreenKey())) {
    return 'mobile';
  }

  return 'desktop';
}

export function commitInitializeStatus(screenSize: ScreenType, isInit: boolean) {
  return store.commit(`gemMeter/${MutationTypes.SET_SCREEN_INITIALIZE_STATUS}`, { screenSize, isInit });
}

export function commitInitialize(isInit: boolean) {
  return store.commit(`gemMeter/${MutationTypes.SET_IS_INITIALIZE}`, isInit);
}

export function getElementOfRule(elementMerId: string) {
  return store.state.gemMeter.elementsOfRules[elementMerId];
}

export function getPageMetric() {
  return store.state.gemMeter.metric;
}

export function getGroupItem() {
  return store.state.gemMeter.groupItem;
}

export function commitGroupLoading(isLoading: boolean) {
  return store.commit(`${MODULE_NAME}/${MutationTypes.CHANGE_GROUP_LOADING}`, isLoading);
}

export function commitResetStore() {
  return store.commit(`${MODULE_NAME}/${MutationTypes.RESET_ALL}`);
}

export function getPageElements() {
  return store.state.gemMeter.pageElements;
}

export function commitClearDataSetting() {
  return store.commit(`editor/${editorMutations.RESET_DATA_SETTINGS}`);
}

export function isLandingPage() {
  return store.state?.app?.pageInfo?.page?.type === 'template-page';
}

export function isPagePublished() {
  return store.state?.app?.pageInfo?.page?.isPublished;
}
